import Blog from "features/public/blog/blog";
import Blogs from "features/public/blog/blogs";
import BotsPage from "features/public/bots";
import LandingPage from "features/public/landing-page/landing-page";
import { Route } from "react-router-dom";

// Shared between AuthApp and UnAuthApp. React Router flattens fragments
// inside <Routes>, so these behave as direct children of both route trees.
export const publicRoutes = (
    <>
        <Route index element={<LandingPage />} />
        <Route path="bots/:id" element={<BotsPage />} />
        <Route path="blogs">
            <Route index element={<Blogs />} />
            <Route path=":slug" element={<Blog />} />
        </Route>
    </>
);
